// merchant-dash-frontend/src/services/api/chartOfAccountsService.js
import apiClient from './apiClient';

const chartOfAccountsService = {
  // Get all accounts for the user
  getAccounts: async () => {
    const response = await apiClient.get('/chart-of-accounts');
    return response.data;
  },

  // Get accounts by type
  getAccountsByType: async (accountType) => {
    const response = await apiClient.get(`/chart-of-accounts/type/${accountType}`);
    return response.data;
  },

  // Get account types
  getAccountTypes: async () => {
    const response = await apiClient.get('/chart-of-accounts/account-types');
    return response.data;
  }
};

export default chartOfAccountsService;